import { useRef } from 'react'

import { IconSizes, PlusCircleLineIcon } from '@inno-ui/icons'
import { Spinner } from '@inno-ui/spinner'
import { useTranslation } from 'react-i18next'
import { useUploadWallpaperMutation } from 'shared/api/containerApi/requests/uploadWallpaper'
import { useWallpaperStore } from 'shared/stores/wallpaperStore'

import styles from './UploadWallpaper.module.scss'

export const UploadWallpaper = () => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop.wallpaper'
  })
  const addCustomWallpaper = useWallpaperStore(
    state => state.addCustomWallpaper
  )

  const uploadWallpaperMutation = useUploadWallpaperMutation({
    onSuccess: response => {
      if (response?.data?.id && response?.data?.url) {
        addCustomWallpaper({
          id: response.data.id,
          image: response.data.url
        })
      }
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    }
  })

  const handleClick = () => {
    fileInputRef.current?.click()
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      uploadWallpaperMutation.mutate(file)
    }
  }

  const isLoading = uploadWallpaperMutation.isPending

  return (
    <>
      <button className={styles.uploadWallpaper} onClick={handleClick}>
        <PlusCircleLineIcon size={IconSizes.Size24} />
        <h4 className={styles.uploadWallpaperTitle}>{t('upload_wallpaper')}</h4>
        {isLoading && (
          <div className={styles.overlay}>
            <Spinner />
          </div>
        )}
      </button>
      <input
        ref={fileInputRef}
        type='file'
        accept='image/png,image/jpeg,image/webp,.png,.jpg,.jpeg,.webp'
        onChange={handleFileChange}
        className={styles.hiddenInput}
      />
    </>
  )
}
